// eslint-disable-next-line no-unused-vars
import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/header';
import Main from './components/main';
import Footer from './components/footer';
import SystemModal from './components/systemModal';
import CookieBanner from './services/CookieBanner';

import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

function App() {

  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language.startsWith('ar')) {
      document.body.classList.add('arabic');
    } else {
      document.body.classList.remove('arabic');
    }
  }, [i18n.language]);


  return (
    <>
      <GlobalStyles />
      <CookieBanner />
      <SystemModal />
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
